import React from 'react';
import { Link } from 'gatsby';
import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import { LabelButton } from '../Buttons/LabelButton';
import { useContent } from '../../../content/content-provider';
import { TextButton } from '../Buttons';

const styles = makeStyles(() => ({
  link: {
    width: '100%',
  },
}));

const LeaveTableButton = ({
  displayLeaveTable = false,
  className = '',
}: {
  displayLeaveTable?: boolean;
  className?: string;
}) => {
  const classes = styles();
  const [content] = useContent();

  const linkStyle = classnames({
    [classes.link]: !displayLeaveTable,
  });

  return (
    <Link to="/speedy-exit" className={linkStyle}>
      {displayLeaveTable ? (
        <TextButton aria-label="leave table" className={className}>
          {content.buttons.leaveTable}
        </TextButton>
      ) : (
        <LabelButton
          aria-label="leave table"
          className={className}
          label={content.buttons.leaveTable}
        />
      )}
    </Link>
  );
};

export default LeaveTableButton;
